
export const getDefaultMainMenus = () => {
  return [
    {
      title: 'Home',
      route: 'home',
      img: 'static/icons/b2b/accounting-active.svg',
      hasPermission: true,
      hasParam: false,
      children: []
    },
    {
      title: 'royalty_account',
      route: 'royalties',
      img: 'static/icons/b2b/accounting-active.svg',
      hasPermission: true,
      hasParam: false,
      expandable: false,
      children: []
    },
    {
      title: 'royalty_account',
      route: 'royalties/:royaltyDate',
      img: 'static/icons/b2b/accounting-active.svg',
      hasPermission: true,
      hasParam: true,
      children: []
    },
   

    {
      title: 'Labels',
      route: 'labels',
      img: 'static/icons/b2b/label-inactive.svg',
      hasPermission: true,
      hasParam: false,
      expandable: false,
      children: [
        { icon: 'Boxer Recordings', title: 'Boxer Recordings', route: 'boxer_recordings', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },
        { icon: 'Boxer Digital', title: 'Boxer Digital', route: 'boxer_digital', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },
        { icon: 'Kick Boxer', title: 'Kick Boxer', route: 'kick_koxer', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },]
    },
    {
      title: 'Labels',
      route: 'labels/:labelType',
      img: 'static/icons/b2b/label-inactive.svg',
      hasParam: true,
      hasPermission: true,
      expandable: false,
      children: [
        { icon: 'Boxer Recordings', title: 'Boxer Recordings', route: 'boxer_recordings', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },
        { icon: 'Boxer Digital', title: 'Boxer Digital', route: 'boxer_digital', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },
        { icon: 'Kick Boxer', title: 'Kick Boxer', route: 'kick_koxer', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },]
    },
    {
      title: 'Releases',
      route: 'releases',
      img: 'static/icons/b2b/booking-grey.svg',
      hasPermission: true,
      expandable: false,
      hasParam: false,
      children: [
        { icon: 'Total 2020', title: 'Total 2020', route: 'total_2020', img: 'static/icons/b2b/booking-grey.svg', parent: 'Releases' },
      ]

    },
    {
      title: 'Releases',
      route: 'releases/:releaseItem',
      img: 'static/icons/b2b/booking-grey.svg',
      hasPermission: true,
      hasParam: true,
      expandable: false,
      children: [
        { icon: 'Total 2020', title: 'Total 2020', route: 'total_2020', img: 'static/icons/b2b/booking-grey.svg', parent: 'Releases' },
      ]

    },



  ]
}

